export default "https://static.wetvinfo.com/tv/linux/static/media/allHistory_h.png";